var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOwldefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4687_55475)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.54242H1.75009C2.11169 5.54242 2.46101 5.69497 2.70676 5.96149L9.06895 12.8625L9.86219 12.002L5.61166 7.39024H7.36175C7.72336 7.39024 8.07267 7.54279 8.31842 7.80931L11.0227 10.743L13.7271 7.80931C13.9728 7.54279 14.3221 7.39024 14.6837 7.39024H16.4338L12.1833 12.002L12.9767 12.8627L19.339 5.96149C19.5847 5.69497 19.934 5.54242 20.2956 5.54242H22.0457L18.3977 9.49924V12.4121C18.3977 13.3835 17.9852 14.3163 17.2655 14.9686C15.8647 16.2398 13.66 16.1223 12.354 14.7056L11.0228 13.2612L9.69327 14.7038C8.38728 16.1206 6.18431 16.2398 4.78178 14.9668C4.06209 14.3145 3.64958 13.3817 3.64958 12.4103V9.50083L0 5.54242ZM16.6915 11.3499L14.2462 14.0021C14.4499 14.0883 14.6698 14.1381 14.894 14.1462L14.8922 14.1445C15.3644 14.1602 15.8068 13.9972 16.1403 13.6833C16.4808 13.3642 16.6757 12.9328 16.6915 12.4647V11.3499ZM5.35578 11.3514L7.79918 14.0016C7.59553 14.088 7.3756 14.1381 7.15151 14.1462C6.67932 14.1637 6.23697 13.9989 5.90346 13.6851C5.56292 13.3642 5.36983 12.9328 5.35578 12.4664V12.4103V11.3514ZM11.0216 14.9833L9.86303 16.2423L11.0216 17.4995L12.1819 16.2423L11.0216 14.9833Z",
    fill: "#B9A2FF"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 20,
    height: 20,
    rx: 10,
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4687_55475"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwldefault);
export default __webpack_public_path__ + "static/media/owl.default.351d02d3cce70a90ac074456a892e857.svg";
export { ForwardRef as ReactComponent };